module.exports = __webpack_public_path__ + "img/warning_amber.f245a1d4.svg";